import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogContent,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogOverlay,
    Button,
    Center,
    Icon,
    MenuItem,
    Spinner,
    Text,
    VStack,
    useDisclosure,
    useForceUpdate,
    useToast,
} from '@chakra-ui/react';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import { createRef, useState } from 'react';
import { BiSolidTimer } from 'react-icons/bi';
import { FaCookieBite } from 'react-icons/fa';
import ReactMarkdown from 'react-markdown';
import { useApi } from '../hooks/Api';
import { useAppState } from '../hooks/AppState';
import { Interval } from '../utils/Interval';
import { Hint } from './Hint';

export interface IHintsProps {}

export const Hints = observer((props: IHintsProps) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [loading, setLoading] = useState(false);
    const cancelRef = createRef<HTMLButtonElement>();
    const appState = useAppState();
    const api = useApi();
    const toast = useToast();
    const update = useForceUpdate();

    return (
        <Interval interval={1000} update={() => update()}>
            <>
                <MenuItem onClick={onOpen}>Nápovědy</MenuItem>
                <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
                    <AlertDialogOverlay>
                        <AlertDialogContent color="gray.200">
                            <AlertDialogHeader fontSize="lg" fontWeight="bold">
                                Nápovědy
                            </AlertDialogHeader>

                            <AlertDialogBody>
                                {loading ? (
                                    <Spinner />
                                ) : appState.appState!.state.hints.length > 0 ? (
                                    <VStack alignItems="stretch" spacing={2}>
                                        {appState.appState!.state.hints.map((hint, index) => {
                                            const disabled = !!(
                                                (hint.requirements.previous &&
                                                    index > 0 &&
                                                    !appState.appState!.state.hints[index - 1].content) ||
                                                (hint.requirements.time &&
                                                    (!appState.appState!.state.arrivedAt ||
                                                        moment().diff(appState.appState!.state.arrivedAt, 'minutes') <
                                                            hint.requirements.time)) ||
                                                (hint.requirements.tokens &&
                                                    appState.appState!.state.tokens < hint.requirements.tokens &&
                                                    !appState.appState!.state.gaveUp)
                                            );

                                            return (
                                                <Hint
                                                    key={index}
                                                    title={hint.title}
                                                    lockMessage={
                                                        <>
                                                            Nápovědu si můžete zvyzvednout{' '}
                                                            <strong>
                                                                {hint.requirements.tokens ? (
                                                                    <>
                                                                        za {hint.requirements.tokens}{' '}
                                                                        <Icon as={FaCookieBite} fontSize="smaller" />
                                                                    </>
                                                                ) : (
                                                                    <>zdarma</>
                                                                )}{' '}
                                                                {hint.requirements.time ? (
                                                                    <>
                                                                        po {hint.requirements.time}{' '}
                                                                        <Icon as={BiSolidTimer} fontSize="smaller" />{' '}
                                                                        minutách od příchodu
                                                                    </>
                                                                ) : (
                                                                    <></>
                                                                )}
                                                                {hint.requirements.previous ? (
                                                                    <>po předchozí nápovědě</>
                                                                ) : (
                                                                    <></>
                                                                )}
                                                            </strong>
                                                        </>
                                                    }
                                                    locked={!hint.content}
                                                    disabled={disabled}
                                                    onClick={async () => {
                                                        if (!disabled && !hint.content) {
                                                            setLoading(true);
                                                            const response = await api.message(
                                                                `$hint_${hint.id}`,
                                                                appState,
                                                            );

                                                            if (!response) {
                                                                toast({
                                                                    status: 'error',
                                                                    title: 'Chyba',
                                                                    description: 'Zprávu se nepodařilo odeslat.',
                                                                });
                                                            } else {
                                                                appState.setAppState(response.content);
                                                            }

                                                            setLoading(false);
                                                        }
                                                    }}
                                                >
                                                    {hint.content ? (
                                                        <ReactMarkdown>{hint.content}</ReactMarkdown>
                                                    ) : undefined}
                                                </Hint>
                                            );
                                        })}
                                    </VStack>
                                ) : (
                                    <Center py={8}>
                                        <Text opacity={0.5} fontSize="smaller" fontStyle="italic">
                                            Pro toto stanoviště nejsou k dispozici žádné nápovědy...
                                        </Text>
                                    </Center>
                                )}
                            </AlertDialogBody>

                            <AlertDialogFooter>
                                <Button ref={cancelRef} onClick={onClose}>
                                    Zavřít
                                </Button>
                            </AlertDialogFooter>
                        </AlertDialogContent>
                    </AlertDialogOverlay>
                </AlertDialog>
            </>
        </Interval>
    );
});
